export default "/bitrix/js/landing/ui/panel/formsettingspanel/content/pay-systems/dist/images/message-icon.svg"